export enum OrderUpdateRequestStatus {
	offer = "offer",
	confirmed = "confirmed"
}
